import React from "react";
import { classificationLabel, classificationShort, classificationColor } from "../lib/classification";

/**
 * v3.69 — Tiny pill rendering Sativa/Indica/Hybrid on cards + detail pages.
 * Public-safe descriptor; rendered even when potency display is off.
 * Pass `short` for cramped placements (cards). Use `size="sm"|"md"`.
 */
export default function ClassificationChip({ value, short = false, size = "sm", className = "", testId }) {
  if (!value) return null;
  const color = classificationColor(value);
  const label = short ? classificationShort(value) : classificationLabel(value);
  const padding = size === "md" ? "px-2 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center font-mono uppercase tracking-[0.16em] border ${padding} ${className}`}
      style={{ color, borderColor: color }}
      data-testid={testId || `classification-${value}`}
    >
      {label}
    </span>
  );
}
